module.exports = __webpack_public_path__ + "img/CS-Hybrid-Assembly.ff74a1d1.jpg";